import { render, staticRenderFns } from "./htmlread.vue?vue&type=template&id=03dcb7ef&scoped=true&"
import script from "./htmlread.vue?vue&type=script&lang=js&"
export * from "./htmlread.vue?vue&type=script&lang=js&"
import style0 from "./htmlread.vue?vue&type=style&index=0&id=03dcb7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dcb7ef",
  null
  
)

export default component.exports